<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Kinderen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Met 'kind' bedoelen we ook pleegkind, adoptiekind en stiefkind.
                <div class="space10"></div>
                <b>Pleegkind</b><br/>
                Voor de belasting is een pleegkind een kind van een ander dat door de belastinplichtige wordt opgevoed
                en onderhouden. Dat betekent dat er voor minimaal € {{ this.bedragLevensonderhoud }} per kwartaal
                in {{ this.year }} bijgedragen wordt in de kosten van levensonderhoud.
                <div class="space10"></div>
                Let op! Krijgt de belastingplichtige een pleegvergoeding? Dan beschouwt de Belastingdienst het kind voor
                de
                belasting niet als pleegkind.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Ingeschreven op adres partners
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kies 'Ja, meer dan 6 maanden' als dit kind en de belastingplichtige minstens 6 maanden bij de gemeente
                op hetzelfde adres
                staan ingeschreven. Dit is een van de voorwaarden voor de inkomensafhankelijke combinatiekorting.
                <div class="space10"></div>

                Kies ook ‘Ja’ als de belastingplichtige samen met dit kind een huishouden voerde maar vanwege een
                bijzondere omstandigheid niet op hetzelfde adres stond ingeschreven. Bijvoorbeeld als de
                belastingplichtige samen met dit kind aan boord van een binnenvaartschip zonder vaste ligplaats woonde.
                Of als dit kind om veiligheidsredenen niet ingeschreven is op hetzelfde woonadres.
                <div class="space10"></div>

                Is dit kind in {{ this.year }} overleden en staat het daardoor minder dan 6 maanden op het adres van
                belastingplichtige ingeschreven? Kies dan toch 'Ja'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading12">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse12" aria-expanded="false" aria-controls="collapse12">
                Co-ouderschap
            </button>
        </h2>
        <div id="collapse12" class="accordion-collapse collapse" aria-labelledby="heading12"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kies ook 'Ja, minstens 6 maand co-ouder' als het kind bij de andere ouder stond ingeschreven en aangever
                of de fiscale partner was in {{ this.year }} co-ouder.
                <div class="space10"></div>

                Je bent of je fiscale partner is co-ouder als jij of je fiscale partner met de andere co-ouder heeft
                afgesproken om de dagelijkse opvang en opvoeding van het kind ongeveer gelijk te verdelen. Van gelijke
                verdeling is sprake als het kind in {{ this.year }} minstens 156 dagen van het kalenderjaar bij jouw
                huishouden hoorde. Dit is gemiddeld 3 dagen per week. Je mag hiervoor dagdelen bij elkaar optellen.
                <div class="space10"></div>
                <b>Voorbeeld</b><br/>
                In week 1 woonde het kind 2 dagen bij jou en je fiscale partner, en 5 dagen bij de andere co-ouder. In
                week 2 woonde je kind 4 dagen bij jou en je fiscale partner, en 3 dagen bij de andere co-ouder. Gemiddeld
                over 2 weken woonde je kind dan 3 dagen per week bij jou en je fiscale partner, en 4 dagen per week bij de
                andere co-ouder. Jij en je fiscale partner voldoen aan de eis dat de dagelijkse opvang en opvoeding van
                het kind ongeveer gelijk verdeeld was tussen beide co-ouders. Ook voldoet jij en je fiscale partner aan de
                156-dagen-eis.
                <div class="space10"></div>
                <b>Co-ouderschap voor een deel van het jaar</b><br/>
                Begon of eindigde het co-ouderschap in {{ this.year }}? Kies dan ‘Ja’ als je aan de volgende voorwaarden voldoet:<br/>
                <ul>
                    <li>Jij of jefiscale partner was in {{ this.year }} minstens 6 maanden co-ouder.</li>
                    <li>Het kind verbleef gemiddeld 3 of meer dagen per week bij jou en je fiscale partner.
                        Dit bereken je als volgt: deel het aantal dagen van het co-ouderschap door 366 en vermenigvuldig de
                        uitkomst met 156 dagen.</li>
                </ul>
                <b>Voorbeeld</b><br/>
                Je was vanaf 1 juni {{ this.year }} tot en met 31 december {{ this.year }} co-ouder van je kind. Dat zijn 214 dagen. Het
                minimum aantal dagen is in dit voorbeeld 91 dagen (214/366 dagen x 156 dagen = 91 dagen).

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Minderjarige kinderen en inkomsten
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Wie geeft wat aan?</b><br/>
                Dat hangt ervan af welke inkomsten je minderjarige kind heeft. Sommige inkomsten geeft je kind zelf aan
                en andere moet jij in je eigen aangifte aangeven.
                <div class="space10"></div>

                <b>Looninkomsten geeft je kind zelf aan</b><br/>
                Heeft je kind inkomsten uit loondienst of winst uit onderneming? Daarover doet je kind zelf aangifte.
                Als het om een bijbaan gaat, is de kans groot dat je kind belasting terugkrijgt.
                <div class="space10"></div>

                <b>Overige inkomsten geeft jij in je eigen aangifte aan</b><br/>
                Als je kind 1 of meer van de volgende soorten inkomsten heeft, geef jij dat op in jouw aangifte:
                <li class="list">inkomsten uit eigen woning (eigenwoningforfait)</li>
                <li class="list">inkomsten uit aanmerkelijk belang</li>
                <li class="list">inkomsten uit sparen en beleggen, met uitzondering van groene beleggingen</li>
                <li class="list">ontvangen dividend</li>
                <li class="list">inkomsten uit het ter beschikking stellen van vermogensbestanddelen</li>
                <div class="space10"></div>
                Oefent meer dan één ouder het gezag uit, zoals bijvoorbeeld bij co-ouderschap het geval is? Dan worden
                bovenstaande inkomsten van je kind in gelijke delen aan beide ouders toegerekend.
                <div class="space10"></div>

                <b>Groene beleggingen</b><br/>
                Heeft je minderjarige kind groene beleggingen? Dan moet je kind zelf aangifte doen om de vrijstelling te
                krijgen. Het bedrag boven de vrijstelling, geeft jij aan in je aangifte bij box 3 (Beleggingen).
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="4">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                Bezittingen en schulden van je minderjarige kinderen
            </button>
        </h2>
        <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Box 3</b><br/>
                Bereken de waarde van de bezittingen en schulden van je minderjarige kinderen waarover je het ouderlijk
                gezag hebt. Het gaat om je kinderen die op 1 januari van het jaar waarover je aangifte doet jonger zijn
                dan 18 jaar. Bereken de waarde op 1 januari van dat jaar.
                <div class="space10"></div>

                Heeft je minderjarige kind groene beleggingen? Dan moet je kind zelf aangifte doen om de vrijstelling te
                krijgen. Het bedrag boven de vrijstelling geeft je aan in je aangifte.
                <div class="space10"></div>

                Heb je het hele jaar een fiscale partner? En heeft deze fiscale partner het ouderlijk gezag over
                minderjarige kinderen die geen kinderen van je zijn? Dan bereken je ook het vermogen van de minderjarige
                kinderen van je fiscale partner. Hoe je de bezittingen en schulden van de kinderen aangeeft, is
                afhankelijk van je situatie.
                <div class="space10"></div>

                <b>Je hebt het hele jaar een fiscale partner</b><br/>
                Jij en je fiscale partner geven de totale waarde aan van de bezittingen en schulden van je kinderen en
                de kinderen van je fiscale partner. Jij of je fiscale partner moet wel het ouderlijk gezag over deze
                kinderen hebben.
                <div class="space10"></div>

                <b>Je leeft duurzaam gescheiden</b><br/>
                Leef je het hele jaar duurzaam gescheiden, maar heb je nog geen verzoek ingediend tot echtscheiding of
                tot scheiding van tafel en bed? Dan ben je het hele jaar fiscale partner van je echtgenoot van wie je
                duurzaam gescheiden leeft. Geef de totale waarde aan van de bezittingen en schulden van de kinderen
                waarover je het ouderlijk gezag hebt.
                <div class="space10"></div>

                <b>Je hebt een scheiding aangevraagd</b><br/>
                Heb je in het jaar van aangifte een verzoek tot echtscheiding ingediend of een verzoek tot scheiding van
                tafel en bed? En sta je in dat jaar niet meer bij de gemeente op hetzelfde adres ingeschreven als je
                echtgenoot? Geef dan de helft van de bezittingen en schulden aan van je kinderen waarover je het
                ouderlijk gezag hebt. De andere ouder geeft in zijn eigen aangifte de andere helft aan.
                <div class="space10"></div>

                Heb je in het jaar van aangifte een verzoek tot echtscheiding ingediend of een verzoek tot scheiding van
                tafel en bed? Maar sta je het hele jaar bij de gemeente op hetzelfde adres ingeschreven als je
                (ex-)echtgenoot? Dan ben je dat hele jaar fiscale partner van je (ex-)echtgenoot. Geef de totale waarde
                aan van de bezittingen en schulden van de kinderen waarover je het ouderlijk gezag hebt.
                <div class="space10"></div>

                <b>Je bent gescheiden</b><br/>
                Ben je het hele jaar van aangifte gescheiden? En sta je niet meer allebei op hetzelfde adres
                ingeschreven bij de gemeente? Geef dan de helft van de bezittingen en schulden aan van je kinderen
                waarover je het ouderlijk gezag hebt. De andere ouder geeft in zijn eigen aangifte de andere helft aan.
                <div class="space10"></div>

                <b>Je bent uit elkaar gegaan</b><br/>
                Heb je een fiscale partner, maar ben je uit elkaar gegaan? En sta je niet meer allebei op hetzelfde
                adres ingeschreven bij de gemeente? Geef dan de helft van de bezittingen en schulden aan van je kinderen
                waarover je het ouderlijk gezag hebt. De andere ouder geeft in zijn eigen aangifte de andere helft aan.
                <div class="space10"></div>

                <b>Je hebt het hele jaar geen fiscale partner</b><br/>
                Heb je geen fiscale partner? Dan geef je de helft van de totale waarde aan van de bezittingen en
                schulden van je kinderen waarover je het ouderlijk gezag hebt. De andere ouder geeft in zijn eigen
                aangifte de andere helft aan.
                <div class="space10"></div>

                <b>Deel van het jaar fiscale partner en kiezen voor het hele jaar fiscale partner</b><br/>
                Als je een deel van het jaar een fiscale partner hebt, kun je kiezen om het hele jaar fiscale partners
                te zijn. Je geeft dan de totale waarde van de bezittingen en schulden op 1 januari van dat jaar aan van
                jou, je fiscale partner, je kinderen en de kinderen van je fiscale partner. Het gaat hier om de kinderen
                waarover jij of je fiscale partner het ouderlijk gezag hebben.
            </div>
        </div>
    </div>

</div>

